import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { ContainerTripsReport } from "../../../../Apis/ttrReportsApi";
import { useNavigate } from "react-router-dom";
import TableComponent from "../../../../Common/TableComponent/tableComponent";
import * as XLSX from "xlsx";
import CustomDataTable from "../../../../Common/ReportTable/ReportTable";
import { ZoneWiseContainerTripsReport } from "../../../../Apis/ttrReportsApi";
import ExcelJS from "exceljs";
import Loader from "../../../../Common/Loader/loader";
import isGHMC from "../../../../Common/helper/helpar";
import { getNowDateTime, getOneMonthPastDateTime } from "../../../AssetVehicle/utils/helpers";

const ContainerReport = ({ t }) => {
  const ContainerFromDate = localStorage.getItem("ContainerFromDate");
  const ContainerToDate = localStorage.getItem("ContainerToDate");
  // const headers = ["zone", "totalHookLoaders", "totaltrip"];
  const [getAllContainer, setAllContainer] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState(
    ContainerFromDate || getStartOfCurrentDate()
  );
  const [endDate, setEndDate] = useState(
    ContainerToDate || getCurrentDateTime()
  );
  const [formInput, setFormInput] = useState({
    Date: getCurrentDateTime(),
  });
  const isProd = isGHMC();

  useEffect(() => {
    fetchTripsTonnageData(startDate, endDate);
  }, []);

  const fetchTripsTonnageData = async (startDate, endDate) => {
    try {
      setIsLoading(true);
      const response = await ContainerTripsReport(startDate, endDate);
      const modifiedResponse = response.data.map((item) => ({
        ...item,
        zone: item.zoneName,
      }));
      setAllContainer(modifiedResponse);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    fetchTripsTonnageData(startDate, endDate);
  };

  const containerColumns = [
    {
      name: "S.No",
      selector: (row) => row["slno"],
      //    sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width: "100px",
    },
    {
      name: "Zone",
      selector: (row) => row["zoneName"],
      cell: (row) => (
        <span
          style={{ color: `${row.zoneName === "Total"?"black":"blue"}`, cursor: "pointer" }}
          onClick={() => row.zoneName != "Total"&&handleZoneClick(row)}
        >
          {row["zoneName"]}
        </span>
      ),
      //   sortable: true,
    },
    {
      name: "No.of Vehicles",
      selector: (row) => row["numberOfVehicle"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        // onClick={() => handleTotalCircleVehicleClick(row["circleId"])}
        >
          {" "}
          {row["numberOfVehicle"]}
        </span>
      ),
      //    sortable: true,
    },
    {
      name: "No.of Trips",
      selector: (row) => row["numberOfTrips"],
      cell: (row) => (
        <span
        //  style={{ color: "blue", cursor: "pointer" }}
        // onClick={() => handleCondemnedCircleClick(row["circleId"])}
        >
          {row["numberOfTrips"]}
        </span>
      ),
      //    sortable: true,
    },
    {
      name: "Total QTY(MT)",
      selector: (row) => row["totalQty"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //  onClick={() => handleUnderRepaiCircleClick(row["circleId"])}
        >
          {row["totalQty"]}
        </span>
      ),
      //    sortable: true,
    },
  ];

  // const handleSort = (column) => {
  //   const newSortConfig = {
  //     column,
  //     order: sortConfig.column === column && sortConfig.order === 'asc' ? 'desc' : 'asc',
  //   };
  //   setSortConfig(newSortConfig);
  // };

  const handleZoneClick = async (zone) => {
    try {
      setIsLoading(true);
      const requestData = {
        startDate,
        endDate,
        zoneId: zone.zoneId,
      };
      const response = await ZoneWiseContainerTripsReport(
        startDate,
        endDate,
        requestData.zoneId
      );
      navigate("/zone-container_report", { state: response.data });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options)
    .replace(/\//g, "/")}`;

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Container Report Generated on: ${formattedDate}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Trips&Tonnage");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 4); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 4; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Container Details"
    worksheet.addRow(["", "", "Container TTR Report", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 4); // Merge cells for Container Details from column 2 to 4
    worksheet.getCell(2, 2).value = "Container TTR Report"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 4; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add table header row
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "No.of Vehicles",
      "No.of Trips",
      "Total QTY(MT)",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Center align the cell content
      if (colNumber >= 1 && colNumber <= 5) {
        // Apply background color
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
          bgColor: { argb: "FFFFFFFF" }, // White text color
        };
      }
    });

    // Add data rows and calculate totals
    let totalNumberOfVehicles = 0;
    let totalNumberOfTrips = 0;
    let totalQuantity = 0;

    getAllContainer.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.zoneName?? "N/A",
          item.numberOfVehicle?? "N/A",
          item.numberOfTrips?? "N/A",
          item.totalQty?? "N/A",
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          cell.alignment = { horizontal: "left" }; // Align the columns from 1 to 4 to the left
        });

      // Accumulate totals
      totalNumberOfVehicles += item.numberOfVehicle || 0;
      totalNumberOfTrips += item.numberOfTrips || 0;
      totalQuantity += item.totalQty || 0;
    });

    // Add total row
    const totalRow = worksheet.addRow([
      "",
      "Total",
      totalNumberOfVehicles,
      totalNumberOfTrips,
      totalQuantity,
    ]);

    totalRow.eachCell({ includeEmpty: true }, (cell) => {
      cell.font = boldFont; // Make total row bold
      cell.alignment = { horizontal: "left" };
    });

    // Set column widths
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Container.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const calculateContainerTotals = (data) => {
    const totals = {
      sno: "Total",
      zoneName: "Total",
      numberOfVehicle: 0,
      numberOfTrips: 0,
      totalQty: 0,
    };

    data.forEach((row) => {
      totals.numberOfVehicle += row.numberOfVehicle || 0;
      totals.numberOfTrips += row.numberOfTrips || 0;
      totals.totalQty += row.totalQty || 0;
    });
    return totals;
  };

  const totalZoneRow = calculateContainerTotals(getAllContainer);
  const ContainerDataWithTotal = [...getAllContainer, totalZoneRow];
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">Container TTR Report</h4>
            <div className="card">
              <div className="card-body p-3">
                <div className="row align-items-end">
                  <div className="col-md-10">
                    <form onSubmit={handleFormSubmit}>
                      <div className="row" style={{ textAlign: "left" }}>
                        <div className="col-md-3 ">
                          <label>From Date & Time:</label>
                          <input
                            type="datetime-local"
                            name="FromDate"
                            style={inputStyle}
                            className="form-control"
                            value={startDate}
                            onChange={(e) => {
                              setStartDate(e.target.value);
                              localStorage.setItem(
                                "ContainerFromDate",
                                e.target.value
                              );
                            }}
                            min={getOneMonthPastDateTime()}
                            max={getNowDateTime()}                        
                          />
                        </div>
                        <div className="col-md-3">
                          <label>To Date & Time:</label>
                          <input
                            type="datetime-local"
                            name="ToDate"
                            style={inputStyle}
                            className="form-control"
                            value={endDate}
                            min={startDate}
                            max={getCurrentDateTime()}
                            onChange={(e) => {
                              setEndDate(e.target.value);
                              localStorage.setItem(
                                "ContainerToDate",
                                e.target.value
                              );
                            }}
                          />
                        </div>
                        <div className="col-md-3 ">
                          <button
                            type="submit"
                            className={`btn mt-4 mr-2 ${
                              isProd ? "search-ghmc" : "search-swm"
                            }`}
                          >
                            Search
                          </button>
                          <button
                            type="submit"
                            className={`btn mt-4 ${
                              isProd ? "search-ghmc" : "search-swm"
                            }`}
                            onClick={() => {
                              localStorage.removeItem("ContainerFromDate");
                              localStorage.removeItem("ContainerToDate");
                              setStartDate(getStartOfCurrentDate());
                              setEndDate(getStartOfCurrentDate());
                            }}
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="col-md-2">
                    <div className="text-end mt-3">
                      <button
                        className="btn btn-excel ms-auto"
                        onClick={downloadAsExcel}
                      >
                        <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                        Excel
                      </button>
                    </div>
                  </div>
                </div>
                <div className="mt-3">
                  <CustomDataTable
                    data={ContainerDataWithTotal}
                    footer={true}
                    link={true}
                    isLoading={isLoading}
                    //  handleSort={handleSort}
                    columns={containerColumns}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
    </>
  );
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

export default withTranslation()(ContainerReport);
// Styles for input and button
const inputStyle = {};

const buttonStyle = {};
